import type { ResultadoAvaliacoesDelivery } from "../../../services/avaliacaoDelivery"

export enum AvaliacaoDeliveryActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_INICIO = "ATUALIZAR_INICIO",
    ATUALIZAR_FIM = "ATUALIZAR_FIM",
}

export type AvaliacaoDeliveryActionModel =
    | { type: AvaliacaoDeliveryActionsTypes.CARREGAR; payload: ResultadoAvaliacoesDelivery }
    | { type: AvaliacaoDeliveryActionsTypes.ATUALIZAR_INICIO; payload: number }
    | { type: AvaliacaoDeliveryActionsTypes.ATUALIZAR_FIM; payload: number }
